import { GetterTree } from 'vuex';
import { RootState } from '../..';
import { DashboardState, DashboardGetters, IDashboard, IFiltroLocal, ILayout } from './types';

export const getters: GetterTree<DashboardState, RootState> = {
  [DashboardGetters.FIND_ITEM_GRID_LAYOUT]: (state) => (id: number) => {
    return state.gridLayoutEditor.find(itemLayout => itemLayout.i === id);
  },
  [DashboardGetters.FIND_DASHBOARD]: (state) => (key: string) => {
    return state.dashboardList.find(dash => dash.key === key);
  },
  [DashboardGetters.FIND_LAYOUT_BY_CURRENT_DASH]: (state) => (key: string) => {
    const dash = state.dashboardList.find(dash => dash.key === state.currentDash) as IDashboard;

    if (!dash) return {};

    return dash.layout.find((item: ILayout) => item.i === key);
  },
  [DashboardGetters.FIND_LOCAL_FILTER]: (state) => (id: number) => {
    return state.filtrosLocaisPreenchidos.find((item: IFiltroLocal) => item.i === id);
  },
  [DashboardGetters.IS_CURRENT_DEFAULT_DASHBOARD]: (state) => {
    const dashboard = state.dashboardList.find(dashboard => dashboard.key === state.currentDash);

    if (!dashboard) return false;

    return dashboard.isDefault || false;
  },
  [DashboardGetters.FIND_DEFAULT_DASHBOARD]: (state) => {
    const dashboard = state.dashboardList
      .find(dashboard => dashboard.isSelectedToViewByDefault || dashboard.isDefaultDashboard);
    if (!dashboard) return '';
    return dashboard.key;
  },
  [DashboardGetters.FIND_DASHBOARD_BY_ID]: (state) => (id: number) => {
    return state.dashboardList.find((dashboard: IDashboard) => dashboard.id === id);
  }

};
